export default function Pricing() {
  const phone = "918438237072";

  const plans = [
    {
      name: "Basic",
      price: "₹3,500",
      oldPrice: "₹5,000",
      emi: "₹1,500/mo",
      features: ["3-5 Pages", "Responsive", "Basic SEO", "Fast Delivery"],
    },
    {
      name: "Business",
      price: "₹7,000",
      oldPrice: "₹12,000",
      emi: "₹2,000/mo",
      features: ["Custom Design", "Admin Panel", "Authentication", "Database"],
      highlight: true,
    },
    {
      name: "E-Commerce",
      price: "₹10,000",
      oldPrice: "₹15,000",
      emi: "₹3,000/mo",
      features: ["Products", "Cart & Checkout", "Payments", "Orders"],
    },
  ];

  return (
    <section id="pricing" className="py-16 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-2">
          Simple Pricing
        </h2>
        <p className="text-center text-gray-500 mb-10">
          Choose the plan that fits your needs
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {plans.map((plan, i) => (
            <div
              key={i}
              className={`rounded-xl p-6 text-center transition-all duration-300 ${
                plan.highlight
                  ? "bg-black text-white scale-105 shadow-2xl"
                  : "bg-white border border-gray-200 hover:shadow-lg"
              }`}
            >
              {plan.highlight && (
                <span className="inline-block bg-green-500 text-white text-xs px-3 py-1 rounded-full mb-3">
                  Best Value
                </span>
              )}
              <h3 className="text-xl font-bold">{plan.name}</h3>
              <div className="mt-3">
                <span className={`text-3xl font-bold ${plan.highlight ? "text-white" : "text-gray-900"}`}>
                  {plan.price}
                </span>
                <span className={`text-sm line-through ml-2 ${plan.highlight ? "text-gray-400" : "text-gray-400"}`}>
                  {plan.oldPrice}
                </span>
              </div>
              <p className={`text-sm mt-1 ${plan.highlight ? "text-green-400" : "text-green-600"}`}>
                or {plan.emi}
              </p>
              <div className={`my-4 h-px ${plan.highlight ? "bg-gray-700" : "bg-gray-200"}`}></div>
              <ul className="space-y-2 text-sm">
                {plan.features.map((f, idx) => (
                  <li key={idx}>✓ {f}</li>
                ))}
              </ul>
              <a
                href={`https://wa.me/${phone}?text=${encodeURIComponent(
                  `Hi, I'm interested in your ${plan.name} plan`,
                )}`}
                target="_blank"
                rel="noreferrer"
                className="block mt-6"
              >
                <button
                  className={`w-full py-2.5 rounded-lg text-sm font-semibold transition ${
                    plan.highlight
                      ? "bg-white text-black hover:bg-gray-100"
                      : "bg-black text-white hover:bg-green-600"
                  }`}
                >
                  Get Started
                </button>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}